import React from 'react';

interface MainMenuItemProps {
    show?: boolean;
    icon: any;
    text: any;
    description?: any;
    disabled?: boolean;
    onClick?: CallableFunction;
}
const MainMenuItem = ({ show=true, icon, text, description, disabled=false, onClick=() => {} }: MainMenuItemProps) => {
    if (!show) return null;

    return (
        <div onClick={() => onClick?.()} className={`flex gap-4 items-center p-2 py-5 cursor-pointer ${disabled ? 'pointer-events-none opacity-30' : ''}`} >
            <div >{icon}</div>
            <div className='w-full grid gap-0.5'>
                <span className='text-base font-semibold leading-none'>{text}</span>
                {description && <span className='text-sm text-gray-400 leading-none'>{description}</span>}
            </div>
        </div>
    )
}

export default MainMenuItem;